import { SiteHeader } from "@/components/SiteHeader";
import { Hero } from "@/components/Hero";
import { ExploreHub } from "@/components/ExploreHub";
import { Footer } from "@/components/BusinessSection";
import { PolicyBar } from "@/components/PolicyBar";
import { MerchStrip } from "@/components/MerchStrip";
import { FeaturedPartners } from "@/components/FeaturedPartners";
import FieldNotes from "@/pages/FieldNotes";
import { useSiteContent } from "@/context/SiteContentContext";

function AnnouncementBar({ announcement }) {
  if (!announcement?.enabled || !announcement?.text) return null;
  return (
    <div className="bg-blaze text-white text-center text-sm py-2.5 px-4" data-testid="announcement-bar">
      <span className="font-medium">{announcement.text}</span>
      {announcement.link && (
        <a href={announcement.link} className="underline underline-offset-2 ml-2 font-semibold hover:text-white/80" data-testid="announcement-link">
          {announcement.link_label || "Learn more"}
        </a>
      )}
    </div>
  );
}

export default function Home() {
  const { announcement } = useSiteContent();

  return (
    <div className="App bg-paper">
      <AnnouncementBar announcement={announcement} />
      <SiteHeader />
      <main>
        <Hero />
        <ExploreHub />
        <FeaturedPartners />
        <MerchStrip />
        <FieldNotes embedded />
      </main>
      <PolicyBar />
      <Footer />
    </div>
  );
}
